import React from 'react';
import PropTypes from 'prop-types';
import { find, isEmpty, isNil } from 'lodash';
import { parse } from 'qs';

import {
  Box,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField
} from '@mui/material';
import { Bert } from 'meteor/themeteorchef:bert';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import getWMSLayerNamesFromURL from '../../../modules/get-wms-layer-names-from-url';
import getWMSStyleNamesFromURL from '../../../modules/get-wms-style-names-from-url';

import { WMS_VERSIONS } from '../../../api/Layers/Layers';

const FAILED_FETCH_MESSAGE = 'Failed to fetch';
const LAYERS_URL_PARAM_REGEX = new RegExp('layers', 'i');
const STYLES_URL_PARAM_REGEX = new RegExp('STYLES', 'i');
let allLayerTitles = '';
let allLayerNames = '';

const NewWMSLayerComponent = ({ MapProps, url, setOpenNewLayer }) => {
  const [description, setDescription] = React.useState('');
  const [imagen, setImagen] = React.useState('');
  const [nameLayer, setNameLayer] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [user, setUser] = React.useState('');
  const [layerTitleSelect, setLayerTitleSelect] = React.useState([]);
  const [layerNameSelect, setLayerNameSelect] = React.useState([]);
  const [isURLLoad, setURLLoad] = React.useState(false);
  const [styleSelect, setStyleSelect] = React.useState('');
  const [allStyles, setAllStyles] = React.useState('');

  // const [version, setVersion] = React.useState('');
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };

  const createNewLayer = async () => {
    const newLayer = {
      name: nameLayer,
      description,
      imageUrl: imagen,
      layerType: 'spatial',
      layerSubType: 'WMS',
      owner: MapProps.map.owner,
      attribution: 'Sentinel',
      url,
      wmsVersion: WMS_VERSIONS.V130,
      layerNames: layerNameSelect.join(','),
      layerTitles: layerTitleSelect.join(','),
      styleName: ''
    };
    try {
      await methodPromise('layers.insert', newLayer);
      setOpenNewLayer(false);
      Bert.alert('Layer created!', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
    return true;
  };

  const loadWMSStyles = async () => {
    try {
      const urlQueryParams = parse(url.substring(url.indexOf('?') + 1));
      const stylesParam = find(urlQueryParams, (param, key) => STYLES_URL_PARAM_REGEX.test(key));
      const connectionParams = {
        user,
        password
      };
      if (layerTitleSelect.length > 1) {
        setAllStyles([]);
        Bert.alert('Select only one layer to show the styles', 'warning');
      } else if (!isNil(stylesParam)) {
        Bert.alert('Layers already defined in URL', 'info');
        setAllStyles([stylesParam]);
        // } else if (failedFetchDueToCORS) {
        //   if (event.target.form.layerNamesInput.value.split().length === 1) {
        //     setStyleSelect([]);
        //   }
      } else if (layerTitleSelect.length === 1) {
        const preselectedStyles = await getWMSStyleNamesFromURL(
          url,
          layerNameSelect[0],
          connectionParams
        );
        setAllStyles(preselectedStyles);
      } else {
        Bert.alert('Select only one layer to show the styles', 'warning');
      }
    } catch (err) {
      console.error(err);
      if (err.message === FAILED_FETCH_MESSAGE) {
        // this.setState({ failedFetchDueToCORS: true });
      }
      handleErrorInClient(err);
    }
  };

  const handleChange = event => {
    const { value } = event.target;
    const selectedTitles = typeof value === 'string' ? value.split(',') : value;

    const selectedNames = selectedTitles.map(title => {
      const index = allLayerTitles.indexOf(title);
      return allLayerNames[index];
    });
    setLayerNameSelect(selectedNames);
    setLayerTitleSelect(selectedTitles);
  };

  const loadURL = async () => {
    const urlQueryParams = parse(url.substring(url.indexOf('?') + 1));
    const layersParam = find(urlQueryParams, (param, key) => LAYERS_URL_PARAM_REGEX.test(key));
    try {
      const connectionParams = {
        user,
        password
      };
      if (!isNil(layersParam)) {
        Bert.alert('Layers already defined in URL', 'info');
        allLayerTitles = layersParam;
        allLayerNames = layersParam;
      } else {
        ({ layerTitles: allLayerTitles, layerNames: allLayerNames } = await getWMSLayerNamesFromURL(
          url,
          connectionParams
        ));
        if (isEmpty(allLayerTitles) && isEmpty(allLayerNames))
          Bert.alert('No layers found', 'warning');
      }
      allLayerTitles = allLayerTitles.split(',');
      allLayerNames = allLayerNames.split(',');
      setURLLoad(true);
      Bert.alert('File Loaded', 'success');
    } catch (err) {
      console.error(err);
      Bert.alert(err, 'danger');
    }
  };

  React.useEffect(() => {
    loadURL();
  }, []);

  return (
    <>
      <Box
        component="form"
        sx={{
          flexDirection: 'column',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          gap: 2,
          mb: 2,
          width: '100%'
        }}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="outlined-start-adornment"
          focused
          fullWidth
          size="small"
          label="Nombre"
          onChange={e => {
            setNameLayer(e.target.value);
          }}
          value={nameLayer}
        />
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-multiline-flexible"
            focused
            fullWidth
            label="user"
            size="small"
            readOnly
            value={url}
            sx={{ mr: 1 }}
          />
          <Button
            onClick={() => {
              loadURL();
            }}
            variant="contained"
            size="small"
            style={{
              backgroundColor: '#2A3F90',
              color: 'white'
            }}
          >
            Load
          </Button>
        </Box>
        <TextField
          id="outlined-multiline-flexible"
          focused
          fullWidth
          label="Descripción"
          size="small"
          onChange={e => {
            setDescription(e.target.value);
          }}
          value={description}
        />
        <TextField
          id="outlined-multiline-flexible"
          focused
          fullWidth
          label="user"
          size="small"
          onChange={e => {
            setUser(e.target.value);
          }}
          value={user}
        />
        <TextField
          id="outlined-multiline-flexible"
          focused
          fullWidth
          label="password"
          size="small"
          onChange={e => {
            setPassword(e.target.value);
          }}
          value={password}
        />
        {!isEmpty(allLayerTitles) && isURLLoad === true && (
          <>
            <Box
              component="form"
              sx={{
                display: 'flex',
                alignItems: 'flex-end',
                mb: 2,
                width: '100%'
              }}
              noValidate
              autoComplete="off"
            >
              <FormControl fullWidth sx={{ mr: 1 }}>
                <InputLabel id="demo-multiple-checkbox-label">Layer Titles</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={layerTitleSelect}
                  size="small"
                  onChange={handleChange}
                  input={<OutlinedInput label="Layer Titles" />}
                  renderValue={selected => selected.join(', ')}
                  MenuProps={MenuProps}
                  sx={{ height: '100%' }} // Establecer la altura del Selector al 100%
                >
                  {allLayerTitles.map(item => (
                    <MenuItem key={item} value={item}>
                      <Checkbox checked={layerTitleSelect.indexOf(item) > -1} />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                onClick={() => {
                  loadWMSStyles();
                }}
                variant="contained"
                size="small"
                style={{
                  backgroundColor: '#2A3F90',
                  color: 'white',
                  flexGrow: 1
                }}
              >
                Search for Styles
              </Button>
            </Box>

            {!isEmpty(allStyles) && (
              <FormControl fullWidth>
                <InputLabel id="wms-version-label">Layer styles</InputLabel>
                <Select
                  labelId="wms-version-label"
                  id="wms-version"
                  name="Layer styles"
                  value={styleSelect}
                  onChange={e => {
                    setStyleSelect(e.target.value);
                  }}
                  placeholder="What's the code name for the styles?"
                >
                  {allStyles.map(item => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </>
        )}

        {/* <FormControl fullWidth>
          <InputLabel id="wms-version-label">WMS Version</InputLabel>
          <Select
            labelId="wms-version-label"
            id="wms-version"
            name="wmsVersion"
            value={version}
            onChange={e => {
              setVersion(e.target.value);
            }}
            placeholder="What's the code name for the styles?"
          >
            {Object.values(WMS_VERSIONS.properties).map(({ name, value, humanValue }) => (
              <MenuItem key={name} value={value}>
                {humanValue}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
        <TextField
          id="outlined-multiline-flexible"
          focused
          fullWidth
          label="Imagen"
          size="small"
          onChange={e => {
            setImagen(e.target.value);
          }}
          value={imagen}
        />
        <Button
          onClick={() => {
            createNewLayer();
          }}
          color="success"
          size="small"
          variant="contained"
        >
          Crear Layer
        </Button>
      </Box>
    </>
  );
};
export default NewWMSLayerComponent;

NewWMSLayerComponent.defaultProps = {};
NewWMSLayerComponent.propTypes = {
  url: PropTypes.string.isRequired,
  MapProps: PropTypes.object.isRequired,
  setOpenNewLayer: PropTypes.func.isRequired
};
